function clip(text) {
  const value = String(text || '').replace(/\s+/g, ' ').trim()
  if (!value) return ''
  return value.length > 90 ? `${value.slice(0, 87)}…` : value
}

function byId(list) {
  return new Map((list || []).map((item) => [item.id, item]))
}

function matchKey(match) {
  return [match.opponent, match.kickoff, match.place, match.meeting || '', match.status || ''].join('|')
}

function eventKey(event) {
  return [event.title, event.kickoff, event.place || ''].join('|')
}

function diffMatches(notes, prefix, before, after, meId) {
  const previous = byId(before)
  after.forEach((match) => {
    const old = previous.get(match.id)
    if (!old) {
      notes.push({ id: `match-new:${match.id}`, message: `${prefix}Ny kamp mod ${match.opponent} er oprettet` })
      return
    }
    if (matchKey(old) !== matchKey(match)) {
      const cancelled = match.status === 'cancelled' && old.status !== 'cancelled'
      notes.push({
        id: `match:${match.id}:${matchKey(match)}`,
        message: cancelled
          ? `${prefix}Kampen mod ${match.opponent} er aflyst`
          : `${prefix}Kampen mod ${match.opponent} er opdateret`,
      })
    }
    if (!(match.attendees || []).includes(meId)) return
    const previousMessages = byId(old.messages)
    match.messages.forEach((message) => {
      if (message.authorId === meId) return
      const earlier = previousMessages.get(message.id)
      if (!earlier) {
        const text = clip(message.text)
        notes.push({
          id: `match-message:${message.id}`,
          message: text
            ? `${prefix}${message.authorName} skrev på kampen mod ${match.opponent}: ${text}`
            : `${prefix}${message.authorName} sendte et billede på kampen mod ${match.opponent}`,
        })
      } else if (message.text !== earlier.text || message.image !== earlier.image) {
        notes.push({
          id: `match-message:${message.id}:${clip(message.text)}`,
          message: `${prefix}${message.authorName} opdaterede et indlæg på kampen mod ${match.opponent}`,
        })
      }
    })
  })
}

function diffEvents(notes, prefix, before, after, meId) {
  const previous = byId(before)
  after.forEach((event) => {
    const old = previous.get(event.id)
    if (!old) {
      notes.push({ id: `event-new:${event.id}`, message: `${prefix}${event.title} er oprettet` })
      return
    }
    if (eventKey(old) !== eventKey(event)) {
      notes.push({ id: `event:${event.id}:${eventKey(event)}`, message: `${prefix}${event.title} er opdateret` })
    }
    if (!(event.attendees || []).includes(meId)) return
    const previousMessages = byId(old.messages)
    ;(event.messages || []).forEach((message) => {
      if (message.authorId === meId) return
      const earlier = previousMessages.get(message.id)
      if (!earlier) {
        const text = clip(message.text)
        notes.push({
          id: `event-message:${message.id}`,
          message: text
            ? `${prefix}${message.authorName} skrev på ${event.title}: ${text}`
            : `${prefix}${message.authorName} sendte et billede på ${event.title}`,
        })
      } else if (message.text !== earlier.text || message.image !== earlier.image) {
        notes.push({
          id: `event-message:${message.id}:${clip(message.text)}`,
          message: `${prefix}${message.authorName} opdaterede et indlæg på ${event.title}`,
        })
      }
    })
  })
}

function diffTeam(notes, before, team, meId, prefix) {
  const start = notes.length
  if (!before) {
    if ((team.members || []).some((member) => member.id === meId)) {
      notes.push({ id: `team:${team.id}`, message: `Du er med på ${team.name}`, teamId: team.id })
    }
    return
  }

  const previousMembers = byId(before.members)
  team.members.forEach((member) => {
    if (previousMembers.has(member.id) || member.id === meId) return
    notes.push({ id: `member:${team.id}:${member.id}`, message: `${prefix}${member.name} er kommet med på holdet` })
  })

  const previousPosts = byId(before.posts)
  team.posts.forEach((post) => {
    const old = previousPosts.get(post.id)
    if (!old) {
      if (post.authorId === meId) return
      const text = clip(post.text)
      notes.push({
        id: `post:${post.id}`,
        message: text
          ? `${prefix}${post.authorName} skrev på væggen: ${text}`
          : `${prefix}${post.authorName} lavede et opslag`,
      })
    } else if (post.authorId !== meId && (post.text !== old.text || post.image !== old.image)) {
      notes.push({ id: `post:${post.id}:${clip(post.text)}`, message: `${prefix}${post.authorName} opdaterede et opslag` })
    }
    const previousComments = byId(old?.comments)
    ;(post.comments || []).forEach((comment) => {
      if (comment.authorId === meId) return
      const earlier = previousComments.get(comment.id)
      if (!earlier) {
        notes.push({ id: `comment:${comment.id}`, message: `${prefix}${comment.authorName} kommenterede: ${clip(comment.text)}` })
      } else if (comment.text !== earlier.text) {
        notes.push({ id: `comment:${comment.id}:${clip(comment.text)}`, message: `${prefix}${comment.authorName} opdaterede en kommentar` })
      }
    })
  })

  const previousSeasons = byId(before.seasons)
  team.seasons.forEach((season) => {
    const oldSeason = previousSeasons.get(season.id)
    if (!oldSeason) {
      notes.push({ id: `season:${season.id}`, message: `${prefix}Ny sæson ${season.name} er startet` })
      return
    }
    diffMatches(notes, prefix, oldSeason.matches, season.matches, meId)
    diffEvents(notes, prefix, oldSeason.events, season.events, meId)
    const chair = (team.members || []).some((member) => member.id === meId && member.fineChair)
    const previousClaims = byId(oldSeason.fineClaims)
    ;(season.fineClaims || []).forEach((claim) => {
      if (!chair || claim.mateId === meId) return
      const earlier = previousClaims.get(claim.id)
      if (earlier && earlier.amount === claim.amount) return
      const name = team.members.find((member) => member.id === claim.mateId)?.name || 'En spiller'
      notes.push({
        id: `fine-claim:${claim.id}:${claim.amount}`,
        message: `${prefix}${name} siger de har betalt ${claim.amount} kr i bøder`,
      })
    })
    const oldClaim = (oldSeason.fineClaims || []).find((claim) => claim.mateId === meId)
    const newClaim = (season.fineClaims || []).find((claim) => claim.mateId === meId)
    if (oldClaim && !newClaim) {
      const paidOf = (item) => (item.finePayments || []).find((payment) => payment.mateId === meId)?.amount || 0
      const approved = paidOf(season) > paidOf(oldSeason)
      notes.push({
        id: `fine-claim-done:${oldClaim.id}:${approved ? 'yes' : 'no'}`,
        message: approved
          ? `${prefix}Din indbetaling i bødekassen er godkendt`
          : `${prefix}Formanden afviste indbetalingen i bødekassen`,
      })
    }
  })
  for (let index = start; index < notes.length; index += 1) notes[index].teamId = team.id
}

export function diffActivity(previous, next, meId) {
  if (!previous) return []
  const notes = []
  const prefixTeams = next.length > 1 || previous.length > 1
  const previousTeams = byId(previous)
  next.forEach((team) => {
    const prefix = prefixTeams ? `${team.name}: ` : ''
    diffTeam(notes, previousTeams.get(team.id), team, meId, prefix)
  })
  return notes
}
